import { yupResolver } from "@hookform/resolvers/yup";
import {
  Box,
  TextField,
  Grid,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormHelperText
} from "@material-ui/core";
import { Button } from "components";
import { usePopup } from "hooks/usePopup";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import InputMask from "react-input-mask";
import sellerService from "services/sellerService";
import { Dialog } from "shared";
import * as Yup from "yup";

const schema = Yup.object().shape({
  code: Yup.string()
    .typeError("Código obrigatório")
    .required("Código obrigatório"),
  name: Yup.string().required("Nome obrigatório"),
  phone_number: Yup.mixed()
    .notRequired()
    .nullable()
    .test("phone_number", "Número obrigatório", value => {
      if (value === null) return false;
      return !!(
        value.replace(/[^0-9]/g, "").length >= 10 &&
        value.replace(/[^0-9]/g, "").length <= 11
      );
    }),
  pix_key_type: Yup.string().when("pix_key", {
    is: pix_key => !!pix_key,
    then: Yup.string().required("O campo Tipo da chave é obrigatório"),
    otherwise: Yup.string()
  }),
  beneficiary: Yup.string().when("pix_key", {
    is: pix_key => !!pix_key,
    then: Yup.string().required("O campo Beneficiário é obrigatório"),
    otherwise: Yup.string()
  })
});

export const ModalEdit = ({ openModal, setOpenModal, refresh, dataSeller }) => {
  const { addPopup } = usePopup();

  const [isLoading, setIsLoading] = useState(false);
  const { register, handleSubmit, formState, reset, setValue } = useForm({
    resolver: yupResolver(schema)
  });
  const { errors } = formState;

  const handleClose = () => {
    reset();
    setOpenModal({
      isOpen: false,
      data: {}
    });
  };

  const handleUpdate = async data => {
    try {
      setIsLoading(true);
      await sellerService.updateSeller({
        id: String(dataSeller.id),
        ...data
      });

      addPopup({
        type: "success",
        title: "Seller atualizado com sucesso."
      });
      handleClose();
      refresh();
    } catch (error) {
      if (error?.response?.status !== 401) {
        if (
          error?.response?.messase === "One of the edited values already exists"
        ) {
          addPopup({
            type: "error",
            title: "Um dos valores editados já existe"
          });

          return;
        }

        addPopup({
          type: "error",
          title: "Desculpe, não foi possível atualizar o Seller."
        });
      }
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    setValue("name", dataSeller?.name);
    setValue("phone_number", dataSeller?.phone_number);
    setValue("code", dataSeller?.code);
    setValue("bank", dataSeller?.bank);
    setValue("agency", dataSeller?.agency);
    setValue("account", dataSeller?.account);
    setValue("pix_key", dataSeller?.pix_key);
    setValue("pix_key_type", dataSeller?.pix_key_type);
    setValue("beneficiary", dataSeller?.beneficiary);
  }, [dataSeller]);

  const { onChange, onBlur, ref, name } = register("phone_number");

  return (
    <Dialog
      open={openModal}
      handleClose={handleClose}
      title="Editar Fornecedor"
    >
      <Box component="form" onSubmit={handleSubmit(handleUpdate)}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <TextField
              fullWidth
              {...register("name")}
              error={!!errors?.name}
              helperText={errors?.name?.message}
              variant="outlined"
              label="Nome do fornecedor"
              autoComplete="off"
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <InputMask
              mask="(99) 99999-9999"
              maskChar=" "
              onChange={onChange}
              onBlur={onBlur}
              defaultValue={dataSeller?.phone_number}
            >
              {() => (
                <TextField
                  ref={ref}
                  name={name}
                  fullWidth
                  error={!!errors?.phone_number}
                  helperText={errors?.phone_number?.message}
                  variant="outlined"
                  label="Celular"
                />
              )}
            </InputMask>
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              {...register("code")}
              error={!!errors?.code}
              helperText={errors?.code?.message}
              variant="outlined"
              label="Código do fornecedor"
              autoComplete="off"
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              {...register("bank")}
              variant="outlined"
              label="Banco"
              autoComplete="off"
            />
          </Grid>
          <Grid item xs={12} sm={2}>
            <TextField
              fullWidth
              {...register("agency")}
              variant="outlined"
              label="Agência"
              autoComplete="off"
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <TextField
              fullWidth
              {...register("account")}
              variant="outlined"
              label="Conta"
              autoComplete="off"
            />
          </Grid>

          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              {...register("pix_key")}
              variant="outlined"
              label="Chave pix"
              autoComplete="off"
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <FormControl fullWidth variant="outlined">
              <InputLabel htmlFor="select-pix-type">Tipo da chave</InputLabel>
              <Select
                {...register("pix_key_type")}
                label="Tipo da chave"
                labelId="select-pix-type"
                autoComplete="off"
                error={!!errors?.pix_key_type}
                helperText={errors?.pix_key_type?.message}
                defaultValue=""
              >
                <MenuItem value={"cpf"}>CPF</MenuItem>
                <MenuItem value={"cnpj"}>CNPJ</MenuItem>
                <MenuItem value={"email"}>E-mail</MenuItem>
                <MenuItem value={"phone"}>Celular</MenuItem>
                <MenuItem value={"random"}>Chave aleatória</MenuItem>
              </Select>
              <FormHelperText>{errors?.pix_key_type?.message}</FormHelperText>
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={12}>
            <TextField
              fullWidth
              {...register("beneficiary")}
              variant="outlined"
              label="Beneficiário"
              autoComplete="off"
              error={!!errors?.beneficiary}
              helperText={errors?.beneficiary?.message}
            />
          </Grid>
          <Grid container item justifyContent="flex-end">
            <Button isLoading={isLoading} type="submit" variant="contained">
              Editar
            </Button>
          </Grid>
        </Grid>
      </Box>
    </Dialog>
  );
};
